module.exports = __webpack_public_path__ + "img/22.3546d0cf.jpg";